import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const VariantTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('200')};
    margin-top: ${getPurpurSpacing('300')};
    margin-bottom: ${getPurpurSpacing('150')};
`;

export const BadgeBlockContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('300')};
`;
